export function triggerCsvDownload(file: any, outputFileName?: string, toBuffer: boolean = true) {
  const data = toBuffer ? string2ArrayBuffer(atob(file.fileContents)) : file;
  const blob = new Blob([data], {
    type: 'text/csv;charset=charset=utf-8',
  });
  const url = window.URL.createObjectURL(blob);

  const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

  a.href = url;
  a.download = outputFileName ?? file.fileDownloadName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

// REF: https://stackoverflow.com/questions/34993292/
function string2ArrayBuffer(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

/**
 * Fetches and decodes a file from the given string and decode
 *
 * @param fetchString the url to fetch from
 * @param decode the encoding type to decode from
 */
export async function fetchAndDecodeFile(fetchString: string, decode: string) {
  const decoder = new TextDecoder(decode);
  const response = await fetch(fetchString);

  return decoder.decode(await response.arrayBuffer());
}
